<template lang="pug">
    v-navigation-drawer(fixed clipped class="drawer-margin" v-model="showDashboard")
            v-list
                template(v-for="(menu, i) in menues")
                    v-list-group( v-model="submenuesShowState[i]" no-action)
                        v-list-tile(:key="i" name="lista-sidebar" slot='activator')
                            v-list-tile-action
                                v-icon {{menu.icon}}
                            v-list-tile-content
                                v-list-tile {{menu.name}}
                        v-divider
                        template(v-for="(submenu, j) in menu.g_submenus")
                            v-list-tile(
                                :key="j" name="lista-sidebar" :to="`/${submenu.route}`" @click="toggleSidebar")
                                // :prepend-icon='submenu.icon')
                                v-list-tile-action
                                        v-icon {{submenu.icon}}
                                v-list-tile-content
                                    v-list-tile-title.custom_list_subtitle {{submenu.name}}
                    //v-divider

</template>

<script>
import Colors from '@/mixins/Colors'
//import { items_administrador, items_usuario } from '@/menus/main.js' // estos menú tengo que sacarlo del store
//import { ROL_ADMINISTRADOR, ROL_USUARIO } from '@/config.js'
import { mapState, mapActions, mapGetters } from 'vuex'
import { VListTitle } from 'vuetify'
export default {
    name: 'SideMenu',
    props:{
        /**
         * @description
         */
        // drawer: {
        //     type: Boolean,
        //     default: () => false
        // },
    },
    data: () => {
        return {
            items: null,
            showDashboard : false,
        }
    },
    computed: {
        // Pendiente para cuando tengamos datos de autenticación
        // ...mapState('auth', {
        //     user: state => state.user
        // }),
        ...mapState('sidebar',{
            drawer:'drawer'
        }),

        ...mapState('MenuesModule',{
            menues: 'menues',
        }),

        submenuesShowState: {
            // getter
            get: function () {
                let arrayShow = []
                for(let i=0; i<this.menues.length; i++){
                    arrayShow.push(false)
                }
                return arrayShow
            },
            // setter
            set: function (newVal) {
                return newVal
            }
    }

        

    },
    methods: {
        ...mapActions('sidebar', {
            toggleSidebar: 'toggleSidebar'
        }),

        ...mapActions('MenuesModule',{
            setShowSubmenues: 'setShowSubmenues'
        }),
        showSubmenues: function(index){
            console.log(index)
            // for(let i=0; i<=this.submenuesShowState.length; i++){
            //     this.submenuesShowState[i] = false
            // }
            this.submenuesShowState[index] = !this.submenuesShowState[index]
            console.log(this.submenuesShowState)
        }
    },

    watch: {
        showDashboard(newVal, oldVal) {
            if(this.drawer != newVal){
                this.toggleSidebar()
            }
        },

        drawer(newVal, oldVal) {
            if(this.showDashboard != newVal){
                this.showDashboard = newVal
            }
        },
        
    },
    mixins: {Colors},
    created: function() { /* SET Sidebar */
        // if(this.user.roles.indexOf(ROL_ADMINISTRADOR) != -1)  // is in array
        //     this.items = items_administrador
        // else if(this.user.roles.indexOf(ROL_USUARIO) != -1)  // is in array
        //     this.items = items_usuario
        // console.log('this.menues')
        // console.log(this.menues)
    },
}
</script>

<style lang="scss" scoped>
.drawer-margin{
    margin-top: 64px !important;
    height: calc(100vh - 64px);
}

.custom_list_subtitle{
    white-space: pre-wrap;
    overflow: visible;
    height: auto;
}
</style>
